import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import AccountInfo from '../AccountInfo/AccountInfo.js';

import './PhoneNumber.css';

import planet from '../../../../assets/images/planet.svg';

class PhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirm: false,
      phonenumber: '',
      activeNext: false,
    }
  }

  changeValue = (name, value) => {
    this.setState({
      [name]: value,
    });

    let reg = new RegExp('^(\\+98|0)?9\\d{9}$');
    let valid = reg.test(value);
    if (valid) {
      this.setState({
        activeNext: true,
      })
    } else {
      this.setState({
        activeNext: false,
      })
    }
  }

  closeConfirm = () => {
    this.setState({ confirm: false, })
  }

  onKeyDown = (e) => {
    if (e.keyCode === 8) {
      let reg = new RegExp('^(\\+98|0)?9\\d{9}$');
      let valid = reg.test(e.target.value);
      if (valid) {
        this.setState({
          activeNext: true,
        })
      } else {
        this.setState({
          activeNext: false,
        })
      }
    }
  }
  render() {
    return (
      <Fragment>
        <div className={this.state.confirm ? 'phone-number-blur phone-number d-flex flex-column' : 'phone-number d-flex flex-column'}>
          <div className={this.props.backAnimate ? "phone-number__header backAnimate" : "phone-number__header"}>
            <img src={planet} />
          </div>
          <div className="phone-number__field d-flex flex-column" className={this.props.backAnimate ? "phone-number__field d-flex flex-column fadeAnimation" : "phone-number__field d-flex flex-column"}>
            <label>لطفا شماره موبایل خود را وارد کنید</label>
            <input
              type="number"
              name="phonenumber"
              onChange={e => this.changeValue(e.target.name, e.target.value)}
              value={this.state.phonenumber}
              onKeyDown={this.onKeyDown}
            />
            <span>09</span>
          </div>

          <div className={this.props.backAnimate ? "phone-number__submit d-flex mt-4 fadeAnimation" : "phone-number__submit d-flex mt-4"}>
            <button
              className='btn'
              type="submit"
              onClick={() => { if (this.state.activeNext) { this.props.setLevel(2) } }} >ادامه</button>
          </div>

          <div className={this.props.backAnimate ? "phone-number__privacy mt-3 d-flex flex-column fadeAnimation" : "phone-number__privacy mt-3 d-flex flex-column"}>
            <Link to="/privacy">
              شما با ادامه موافقت خود را مبنی بر  <strong>قبول قوانین
            و مقررات</strong> و حریم خصوصی اعلام می کنید
            </Link>
            <div className="phone-number__privacy--why" onClick={() => this.setState({ confirm: true })} >
              چرا باید شماره خود را بدهم؟
            </div>
          </div>
        </div>
        {this.state.confirm ? <AccountInfo closeConfirm={this.closeConfirm} /> : null}
      </Fragment >
    );
  }
}

export default PhoneNumber;